import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bar from '../common/graphs/bar';
import strings from '../locales/';
import GraphTable from './evolutionGraphTable.jsx';
import GraphTableBar from './evolutionGraphTableBar.jsx';
import MicrosleepsQuantityEvolutionGraph from '../common/roadwarning/microsleepsQuantityEvolutionGraph';

const calc = theform => {
  if (theform) {
    let num = theform;
    let with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,1})?/)[0];
    return with2Decimals;
  } else {
    return 0;
  }
};

const SummaryTable = props => {
  return (
    <section className="main_table">
      <table>
        <thead>
          <tr>
            <th className="main_table_250">{props.language.filter[props.main.toLowerCase()]}</th>
            <th className="main_table_120"> {props.language.summary.tableTitle.drivers} </th>
            <th className="main_table_x2"> {props.language.summary.tableTitle.microSleep}</th>
            <th className="main_table_x2"> {props.language.summary.tableTitle.microSleepBar}</th>
          </tr>
        </thead>
        <tbody>
          {props.indicatorByCategorizations &&
            props.indicatorByCategorizations.map((item, i) => (
              <tr
                data-datos={JSON.stringify(item)}
                onClick={props.link}
                className={item.severity ? item.severity : 'OUTOFRISK'}
                key={`t-fatigue-${i}`}
              >
                <td>
                  <a> {item.tag} </a>
                </td>
                <td>
                  <a> {item.driversCount ? item.driversCount : '0'} </a>
                </td>
                <td>
                  {item.dailyWarningRate.length > 0 ? (
                    <a className="special" data-tags={true} data-name={item.tag}>
                      <GraphTable
                        graphColorRange={props.graphColorRange}
                        data={item.dailyWarningRate}
                        miny={true}
                        id={`grapha-${i}`}
                        tooltip={props.language.driver_roadwarning.labels}
                        language={props.language}
                      />
                      <div className="main_table_num">
                        <h4>{calc(item.warningRate)} </h4>
                      </div>
                    </a>
                  ) : (
                    <a className="special" data-tags={true} data-name={item.tag}>
                      <div className="boxChart" />
                      <div className="main_table_num">
                        <h4>0 %</h4>
                      </div>
                    </a>
                  )}
                </td>
                <td>
                  <a className="special">
                    {item.dailyTotalWarnings.length && (
                      <GraphTableBar
                        data={item.dailyTotalWarnings}
                        miny={true}
                        id={`graphbar-${i}`}
                        tooltip={props.language.driver_roadwarning.labels}
                        language={props.language}
                      />
                    )}
                  </a>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </section>
  );
};

export default SummaryTable;



// WEBPACK FOOTER //
// ./source/client/components/summary_roadwarning/summaryTable.jsx